import { render, staticRenderFns } from "./item-product-create.vue?vue&type=template&id=7af18d2a&"
import script from "./item-product-create.vue?vue&type=script&lang=js&"
export * from "./item-product-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports